import { getServiceCosts } from './getServiceCosts'
import { getFeeCosts } from 'Rentlio/state/selectors/basketFee'

export function getTotalCost(state) {
  const result = {
    total: 0,
    accomodation: 0,
    extras: 0
  }

  const { basket, request } = state

  basket.map(basketItem => {
    result.accomodation += basketItem.totalRate

    basketItem.services.map(service => {
      result.extras += getServiceCosts(service, request)
    })

    basketItem.fees.map(fee => {
      result.extras += getFeeCosts(fee, request)
    })
  })

  result.total = result.accomodation + result.extras
  result.accomodationCount = basket.length

  return result
}
